import { QdzElement, define } from '@qdz/element';

let count = 0;

const scroller = (element) => {
  for (let node = element.parentElement; node && node !== document.body; node = node.parentElement) {
    const { overflowY } = getComputedStyle(node);
    if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
  }
  return window;
};

export function keepAccordionPosition(event) {
  const trigger = event.target.closest?.('summary, [data-accordion-item] [aria-expanded]');
  if (!trigger) return;
  const top = trigger.getBoundingClientRect().top;
  requestAnimationFrame(() => {
    if (!trigger.isConnected) return;
    const shift = trigger.getBoundingClientRect().top - top;
    if (Math.abs(shift) >= 1) scroller(trigger).scrollBy({ top: shift, behavior: 'instant' });
  });
}

document.addEventListener('click', keepAccordionPosition, true);

export class QdzInfoTabs extends QdzElement {
  get items() {
    return [...this.querySelectorAll('.qdz-info-tab')].filter((item) => item.closest('qdz-info-tabs') === this);
  }

  get tabs() {
    return [...(this.ref('tablist')?.children ?? [])];
  }

  mount() {
    const list = this.ref('tablist');
    if (!list) {
      if (this.hasAttribute('multiple')) for (const item of this.items) item.removeAttribute('name');
      return;
    }
    const items = this.items;
    const start = Math.max(items.findIndex((item) => item.open), 0);
    const tabs = items.map((item, index) => {
      const id = `qdz-info-tab-${(count += 1)}`;
      const body = item.querySelector('.qdz-info-tab__body');
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = this.getAttribute('tab-class') || 'qdz-info-tabs__tab';
      tab.id = id;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', `${id}-panel`);
      tab.textContent = item.querySelector('.qdz-info-tab__title').textContent;
      body.id = `${id}-panel`;
      body.setAttribute('role', 'tabpanel');
      body.setAttribute('aria-labelledby', id);
      body.tabIndex = 0;
      item.removeAttribute('name');
      item.open = true;
      this.listen(tab, 'click', () => this.select(index));
      this.listen(tab, 'keydown', (event) => this.#onKeydown(event, index));
      return tab;
    });
    list.replaceChildren(...tabs);
    this.select(start, false);
  }

  select(index, focus = true) {
    this.tabs.forEach((tab, position) => {
      tab.setAttribute('aria-selected', String(position === index));
      tab.tabIndex = position === index ? 0 : -1;
    });
    this.items.forEach((item, position) => {
      item.hidden = position !== index;
    });
    if (focus) this.tabs[index]?.focus();
  }

  editorSelect(event) {
    const index = this.items.findIndex((item) => item.contains(event.target) || event.target.contains(item));
    if (index >= 0 && this.ref('tablist')) this.select(index, false);
  }

  #onKeydown(event, index) {
    const total = this.tabs.length;
    const moves = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: total - 1 };
    if (!(event.key in moves)) return;
    event.preventDefault();
    this.select((moves[event.key] + total) % total);
  }
}

define('qdz-info-tabs', QdzInfoTabs);
